import { JSX } from 'react';
import { ReactSVG, Props as ReactSVGProps } from 'react-svg';
import { IconSize } from '../../types/icon';

interface ExternalSvgIconProps extends ReactSVGProps {
    size?: IconSize;
    className?: string;
    wrapperClassName?: string;
}

function ExternalSvgIcon(props: ExternalSvgIconProps): JSX.Element {
    const defaultSize: IconSize = 64;

    return (
        <ReactSVG
            src={props.src}
            title={props.title}
            className={props.wrapperClassName}
            width={props.size ?? defaultSize}
            height={props.size ?? defaultSize}
            beforeInjection={(svg) => {
                svg.classList.add(...(props.className?.split(' ') ?? []));
                svg.setAttribute('width', `${props.size ?? defaultSize}`);
                svg.setAttribute('height', `${props.size ?? defaultSize}`);
            }}
        />
    );
}

export default ExternalSvgIcon;
